<template>
  <v-snackbar
    v-for="notification in notifications"
    :key="notification.id"
    :model-value="true"
    :color="getColor(notification.type)"
    :timeout="notification.timeout || 5000"
    location="top right"
    @update:model-value="removeNotification(notification.id)"
  >
    <v-icon :icon="getIcon(notification.type)" class="mr-2" />
    {{ notification.message }}

    <template #actions>
      <v-btn variant="text" @click="removeNotification(notification.id)">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useNotificationStore } from "@/store/notificationStore";

const notificationStore = useNotificationStore();

const notifications = computed(() => notificationStore.notifications);

const getColor = (type: string) => {
  const colors = {
    success: "success",
    error: "error",
    warning: "warning",
    info: "info",
  };
  return colors[type as keyof typeof colors] || "info";
};

const getIcon = (type: string) => {
  const icons = {
    success: "mdi-check-circle",
    error: "mdi-alert-circle",
    warning: "mdi-alert",
    info: "mdi-information",
  };
  return icons[type as keyof typeof icons] || "mdi-information";
};

const removeNotification = (id: string) => {
  notificationStore.removeNotification(id);
};
</script>
